import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ToastModule } from 'primeng/toast';
import { CommonModule } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import { TranslationService } from 'lib-base';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule, RouterOutlet,
    ToastModule,
  ],
  template: `
    <p-toast></p-toast>
    <router-outlet></router-outlet>
  `,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  horizontalMenu !: boolean;

  darkMode = false;

  menuColorMode = 'light';

  menuColor = 'layout-menu-light';

  themeColor = 'blue';

  layoutColor = 'blue';

  ripple = true;

  inputStyle = 'outlined';

  constructor(private primengConfig: PrimeNGConfig, private translate: TranslationService) { }

  ngOnInit() {
    this.primengConfig.ripple = true;
  }
}
